import React, { useState } from 'react';
import api from '../lib/api';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';


function CreateBoardModal({ onClose, onBoardCreated }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error('Board name is required');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post(
        `/boards`,
        { name: name.trim() },
        
      );
      toast.success('Board created successfully');
      onBoardCreated(response.data);
    } catch (error) {
      console.error('Failed to create board:', error);
      toast.error('Failed to create board');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full border border-stone-200" data-testid="create-board-modal">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-stone-200">
          <h2 className="text-xl font-bold text-stone-900">Create New Board</h2>
          <button
            onClick={onClose}
            data-testid="close-create-board-modal"
            className="p-2 hover:bg-stone-100 rounded-xl transition-colors"
          >
            <X className="w-5 h-5 text-stone-500" strokeWidth={1.5} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-6">
            <label className="block text-sm font-medium text-stone-700 mb-2">
              Board Name
            </label>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Product Development"
              data-testid="board-name-input"
              className="w-full rounded-xl"
              autoFocus
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              data-testid="cancel-create-board"
              className="bg-white border border-stone-200 hover:bg-stone-50 text-stone-700 rounded-xl"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={loading}
              data-testid="submit-create-board"
              className="bg-primary hover:bg-primary-hover text-stone-900 rounded-xl shadow-gold font-semibold"
            >
              {loading ? 'Creating...' : 'Create Board'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateBoardModal;
